import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { ParticipantSalesDataTableResponse } from "../../Interfaces/TeamAdminCoordDashboard";

interface ParticipantSalesDataTableDownloadButtonProps {
  total_sales_data: ParticipantSalesDataTableResponse[];
  width: number;
  height: number;
  one_col: boolean;
  file_name: string;
}

const SummaryButtonDownload: React.FC<
  ParticipantSalesDataTableDownloadButtonProps
> = ({ total_sales_data, one_col, file_name }) => {
  const generatePDF = () => {
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    pdf.setFontSize(16);
    pdf.text("Fundraiser Participant Summary", 105, 20, { align: "center" });

    // Define Table Headers
    const headers = one_col
      ? [["Participant", "Total Sales"]]
      : [
          [
            "Participant",
            "Primary Division",
            "Secondary Division",
            "Items Sold",
            "Total Sales",
            "Total Profit",
          ],
        ];

    // Convert Data into Rows
    const data = total_sales_data.map((entry) =>
      one_col
        ? [entry.participant_name, `$${entry.total_sales.toFixed(2)}`]
        : [
            entry.participant_name,
            entry.primary_div,
            entry.secondary_div,
            entry.num_items_sold,
            `$${entry.total_sales.toFixed(2)}`,
            `$${entry.total_profit.toFixed(2)}`,
          ]
    );

    // Generate Table
    autoTable(pdf, {
      head: headers,
      body: data,
      startY: 30,
      theme: "grid",
      margin: { top: 30 },
      styles: { fontSize: 10, cellPadding: 3 },
      headStyles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] },
      columnStyles: {
        3: { halign: "right" },
        4: { halign: "right" },
        5: { halign: "right" },
      }, // Right-align numerical columns
    });

    // Save PDF
    pdf.save(file_name);
  };
  return (
    <div className="team-admin-black-button-wrapper" onClick={generatePDF}>
      Download Sales Summary
    </div>
  );
};

export default SummaryButtonDownload;
